(function() {
  'use strict';

  // configure routes
  angular
    .module(moduleConfig.applicationModuleName)

    .config([
      '$compileProvider',
      '$sessionStorageProvider',
      '$stateProvider',
      '$urlRouterProvider',
      'env',
      '$locationProvider',
      'uteEndpointProvider',
      '$sceDelegateProvider',
      '$httpProvider',
      '$translateProvider',
      'uiGmapGoogleMapApiProvider',
      '$provide',
      'tmhDynamicLocaleProvider',
      'cfpLoadingBarProvider',
      'IdleProvider',
      function(
        $compileProvider,
        $sessionStorageProvider,
        $stateProvider,
        $urlRouterProvider,
        env,
        $locationProvider,
        uteEndpointProvider,
        $sceDelegateProvider,
        $httpProvider,
        $translateProvider,
        uiGmapGoogleMapApiProvider,
        $provide,
        tmhDynamicLocaleProvider,
        cfpLoadingBarProvider,
        idleProvider
      ) {
        var mySerializer = function(value) {
          if (typeof value === 'string') {
            return value;
          } else {
            return angular.toJson(value);
          }
        };

        $sessionStorageProvider.setSerializer(mySerializer);

        tmhDynamicLocaleProvider.localeLocationPattern(
          'assets/bower_components/angular-i18n/angular-locale_{{locale}}.js'
        );

        // disable debug information
        $compileProvider.debugInfoEnabled(false);

        // use the HTML5 History API
        // $locationProvider.html5Mode(true);

        //Disable caching
        $httpProvider.defaults.cache = false;
        if (!$httpProvider.defaults.headers.get) {
          $httpProvider.defaults.headers.get = {};
        }

        //Idle time settings for logging out user
        idleProvider.idle(env.idleTimeInSeconds);
        idleProvider.timeout(env.timeoutTimeInSeconds);

        // disable IE ajax request caching
        $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
        $httpProvider.defaults.withCredentials = true;

        // http interceptors
        $httpProvider.interceptors.push('httpInterceptor');

        $sceDelegateProvider.resourceUrlWhitelist([
          'self',
          'http://ute-qa02.fido.ca:8080/**',
          'http://*.fido.ca:8080/**',
          'https://slack-files.com/**',
          'http://*.fido.ca/**',
          'https://*.fido.ca/**'
        ]);

        // console.log('ENV:', env.name);
        // setup default router for language files
        // Timestamp should be added manually, append the timestamp manually
        // TODO: find a way to update as part of build process
        $translateProvider.useStaticFilesLoader({
          prefix: env.i18nUrlPrefix,
          suffix: '.json?v=20200122'
        });

        // configure endpoints so that we can use simplified urls
        uteEndpointProvider.setBaseUrl(env.apiBaseUrl);
        uteEndpointProvider.setCMSContentURL(env.cmsContentURL);
        uteEndpointProvider.setBasePath(env.apiBasePath);
        if (env.custom) {
          uteEndpointProvider.setEndpoints(env.custom);
        }

        // cybersource url configuration

        // uteCyberSourceProvider.setSignatureUrl(env.apiBaseUrl + env.apiBasePath + '/v2/paymentSignature');
        // uteCyberSourceProvider.setDecryptionUrl(env.apiBaseUrl + env.apiBasePath + '/v2/paymentDecrypt');

        // function stripTrailingSlash(str) {
        //   if (str.substr(-1) === '/') {
        //     return str.substr(0, str.length - 1);
        //   }
        //   return str;
        // }
        //
        // function redirectToLiveSite() {
        //   // ensure we aren't doing a circular redirect here (only possible on local)
        //   if (env.name !== 'local' && stripTrailingSlash(window.location.href) !== stripTrailingSlash(env.fidoHomePageUrl)) {
        //     window.location.href = env.fidoHomePageUrl;
        //   }
        // }

        // redirections
        // $urlRouterProvider.when('', redirectToLiveSite);
        // $urlRouterProvider.when('/', redirectToLiveSite);

        // for any unmatched urls, go to 404
        $urlRouterProvider.otherwise(function($injector, $location) {
          var state = $injector.get('$state');
          state.go('error404');
          return $location.path();
        });
        var googleEid = 'AIzaSyCdffW3oM5B0ltY0E2Y3z5iOoLsZBQ3bEM';
        // for angular-google-maps
        uiGmapGoogleMapApiProvider.configure({
          key: googleEid,
          v: '3.17',
          libraries: 'places, visualization'
        });

        //decorator to replace () with - sign for negative currency values
        $provide.decorator('$locale', [
          '$delegate',
          function($delegate) {
            if ($delegate.id == 'en-us') {
              $delegate.NUMBER_FORMATS.PATTERNS[1].negPre = '-\u00A4';
              $delegate.NUMBER_FORMATS.PATTERNS[1].negSuf = '';
            }
            return $delegate;
          }
        ]);

        //Hide the spinner from angular loading bar at top
        cfpLoadingBarProvider.includeSpinner = false;

        // state declaration below:
        // declaring state 'app' which will be the global state that the rest will be children to.
        // all top-level nav items need to be child states of this state (declaring " ... parent: 'app', url: '^...' ... " in child state will suffice)
        $stateProvider
          .state('app', {
            abstract: true,
            template: '<div ui-view="content"></div>',
            controller: 'appCtrl',
            resolve: {
              getAccountDetails: [
                'commonService',
                '$rootScope',
                '$q',
                '$location',
                function(commonService, $rootScope, $q, $location) {
                  if (
                    $location.path().toLowerCase() === '/cfaLanding'.toLowerCase() ||
                    $location.path().toLowerCase() === '/logout'.toLowerCase()
                  ) {
                    var deferred = $q.defer();
                    setTimeout(function() {
                      deferred.resolve();
                    }, 20);
                    return deferred.promise;
                  }
                  return $rootScope.ruiMethods.user.is.loggedIn()
                    ? commonService.getAccountDetails($rootScope.userInfo.accounts)
                    : false;
                }
              ],
              getBrtSwitchDetails: [
                'brtSwitchCMS',
                function(brtSwitchCMS) {
                  if (!brtSwitchCMS.brtSwitch.fetchCMSComplete) {
                    return brtSwitchCMS.getBRTStatus();
                  }
                  return true;
                }
              ]
            }
          })
          // define page not found state
          .state('error404', {
            url: '/not-found',
            parent: 'app',
            title: 'notFound',
            views: {
              content: {
                templateUrl: 'modules/app/views/404.html'
              }
            }
          })
          .state('logout', {
            url: '/logout?return',
            parent: 'app',
            title: 'loggingOut',
            views: {
              content: {
                templateUrl: 'modules/app/views/logout.html',
                controller: 'logoutCtrl'
              }
            },
            params: {
              cfaLoggingOut: false
            }
          })
          .state('home', {
            url: '/',
            parent: 'app',
            title: 'home',
            views: {
              content: {
                template: ''
              }
            }
          })
          .state('maintenance', {
            url: '/maintenance',
            parent: 'app',
            title: 'maintenance',
            views: {
              content: {
                templateUrl: 'modules/app/views/maintenance.html'
              }
            }
          })
          .state('unsupportedDevice', {
            url: '/unsupported-device',
            parent: 'app',
            title: 'home',
            views: {
              content: {
                templateUrl: 'modules/app/views/unsupported-device.html'
              }
            }
          })
          .state('changeInternetPkg', {
            url: '/change/internet',
            parent: 'app',
            title: 'changeInternetPackage',
            data: {
              authRequired: true
            },
            views: {
              content: {
                templateUrl: 'modules/my-account/internet/change-internet.html',
                controller: 'changeInternetCtrl'
              }
            }
          })
          .state('storeLocator', {
            url: '/storelocator',
            parent: 'app',
            title: 'storeLocator',
            views: {
              content: {
                templateUrl: 'modules/app/views/store-locator.html',
                controller: 'storeLocatorCtrl'
              }
            }
          })
          .state('modemReceipt', {
            url: '/self-serve-modem-receipt',
            parent: 'app',
            title: 'modemReceipt',
            views: {
              content: {
                templateUrl: 'modules/app/views/self-serve-modem-receipt.html',
                controller: 'selfServeModemReceiptCtrl'
              }
            },
            params: {
              status: '',
              workOrderNo: '',
              equipmentId: '',
              details: '',
              action: '',
              returnModemSerial: '',
              pickUpModemSerial: ''
            }
          });
      }
    ]);
})();
